// COMPONENTS
import LoggedIn from "../../layouts/loggedIn.layout";
import ManualStatementPage from "./page.manualstatement.page";

const StatementsLayout = () => {
  return (
    <LoggedIn>
           <ManualStatementPage />
    </LoggedIn>
  );
};

export default StatementsLayout;
